import objectPath from 'object-path';

const getPlanParcelSailis = (order) => {
  const planParcel = (order.sailis_meta.planParcel && order.sailis_meta.planParcel[0]) || {};
  const planParcelDisplay = objectPath.get(planParcel, 'identifier.displayName') || '';

  return planParcelDisplay;
};

const mapPlanParcelMeta = (planParcels = [], volFolio = {}, titleReference) => {
  const pp = planParcels[0];

  const planParcelDisplay = (pp
    ? `${pp.planType}${pp.planNumber} ${pp.parcelType || ''} ${pp.parcelTypeDescription || ''} ${pp.parcelNumber || ''}`
    : '').trim();

  if (!volFolio.volFolPrefix || !volFolio.volume || !volFolio.folio) {
    return `${titleReference ? titleReference+' ' : ''}${planParcelDisplay}`;
  }

  const volFolioDisplay = volFolio
    ? `${volFolio.volFolPrefix}${volFolio.volume}/${volFolio.folio}`
    : '';

  return `${volFolioDisplay} ${planParcelDisplay}`;
};

const getPlanParcelGlobalX = (order) => {
  const titleReference = objectPath.get(order.globalx_meta, 'titleReference');
  const volFolio       = objectPath.get(order.globalx_meta, 'volumeFolio');
  const planParcels    = objectPath.get(order.globalx_meta, '_embedded.planParcels') || [];
  const lotPlan        = objectPath.get(order.globalx_meta, 'lotPlan');


  return mapPlanParcelMeta(lotPlan ? [ lotPlan ] : planParcels, volFolio, titleReference);
};

export const getPlanParcel = (order = {}) => {
  if (Object.getOwnPropertyNames(order.meta || {}).length) {
    return mapPlanParcelMeta(order.meta.planParcels, order.meta.volumeFolio, order.meta.titleReference);
  }

  if (order.sailis_meta) {
    return getPlanParcelSailis(order);
  }

  if (order.globalx_meta) {
    return getPlanParcelGlobalX(order);
  }

  return (order.address_ct || order.address_plan_lot_section)
    ? [ order.address_ct || '', order.address_plan_lot_section || '' ].join(' ')
    : '';
}

export default getPlanParcel;
